import languages from '../languages';
import { accountNameValidate, pwdValidate } from '../validator';
import {
  getJSON,
  PASSPORT_HOST,
  getJSONWithoutEntryParam,
  HOME_HOST
} from '../ultile';

import logoConfig from '../logoConfig';

import { encryption } from '../../utiles';

import services from '../services';

import globalConfig from '../../utiles/globalConfig';
const mainHost = globalConfig.getMainHost();

languages.init();

export const UPDATE_GAME_LIST = 'update_game_list';
export const GET_GAME_INFO = 'get_game_info';
export const CHECK_GAME = 'checkGame';
export const UPDATE_GAMEID = 'update_gameid';
export const UPDATE_THIRD_LIST = 'update_third_list';
export const UPDATE_GAME_LOGIN_TYPE = 'update_game_login_type';
export const UPDATE_GAME_LOGIN_TYPE_BY_USERTYPE =
  'update_game_login_type_by_usertype';
export const UPDATE_USER_ACCOUNT_STATE = 'update_user_account_state';
export const UPDATE_USER_PASSWORD_STATE = 'update_user_password_state';
export const UPDATE_USER_REPASSWORD_STATE = 'update_user_repass_state';
export const UPDATE_REGISTER_TERM_STATE = 'update_register_term_state';
export const UPDATE_IS_LEGAL_FORWARD = 'update_is_legal_forward_state';
export const UPDATE_USER_ACCOUNT = 'update_user_account';
export const UPDATE_USER_PASSWORD = 'update_user_password';
export const UPDATE_USER_REPASSWORD = 'update_user_repass';
export const UPDATE_TIPS = 'update_tips';
export const UPDATE_LOGIN_REQUEST = 'update_login_request';
export const UPDATE_REGISTER_REQUEST = 'update_register_request';
export const UPDATE_REMEMBER = 'update_remember';
export const UPDATE_USER_INFO = 'update_user_info';
export const RESET_USER_INFO = 'reset_user_info';
export const UPDATE_FORWARD_STATE = 'update_forward_state';
export const RESET_DATA = 'reset_data';

export const JUDGE_USER_ACCOUNT = 'judge_user_account';
export const JUDGE_USER_PASSWORD = 'judge_user_password';
export const JUDGE_USER_REPASSWORD = 'judge_user_repassword';
export const JUDGE_IS_LOGIN = 'judge_is_login';
export const JUDGE_REGISTER_TERM = 'judge_register_term';
export const JUDGE_FORWARD_IS_VERIFY = 'judge_forward_is_verify;';
export const GET_USER_TOKEN = 'get_user_token';
export const GO_LOGIN = 'go_login';
export const GO_REGISTER = 'go_register';
export const GO_RO_LOGIN_BIND_ACCOUNT = 'go_ro_login_bind_account';
export const GO_LOGOUT = 'go_logout';
export const GOTO_REGISTER = 'goto_register';
export const GOTO_LOGIN = 'goto_login';
export const LOGIN_CHECK = 'login_check';
export const REGISTER_CHECK = 'register_check';
export const GO_THIRD_LOGIN = 'go_third_login';
export const GO_BACK_SELECT_GAME = 'go_back_select_game';
export const GOTO_UID_TOKEN_LOGIN = 'goto_uid_token_login';
export const GO_BACK_SELECT_THIRD_PARTY_LOGIN =
  'go_back_select_third_party_login';
export const GO_UID_TOKEN_LOGIN = 'go_uid_token_login';
export const SWITCH_LANGUAGE = 'switch_language';
export const setLanguage = languages.setLanguage;
export const CHECK_NEED_VERIFICATION_CODE = 'check_need_verification_code';

export const UPDATE_FAKE_PASSWORD_REPEAT = 'update_fake_password_repeat';
export const SHOW_FAKE_PASSWORD_REPEAT = 'show_fake_password_repeat';

// 二维码登录相关
export const GENERATE_QR_CODE = 'generate_qr_code';
export const CHECK_QR_CODE_STATUS = 'check_qr_code_status';
export const HANDLE_QR_CODE_LOGIN = 'handle_qr_code_login';

const HTTP = 'https:';
export const HOME_PAGE = `https://www.${mainHost}`;
// mainHost == "vgm.vn" || mainHost == "3syua.com"
//   ? `https://gwww.${mainHost}`
//   : `https://www.${mainHost}`;
export const DEFAULT_ICON = `//gabres.${mainHost}/commonImg/storeDefault/${mainHost}.png`;

export const paramForward = decodeURIComponent(
  globalConfig.getHrefParamUndecode('forward') || HOME_PAGE
);
const forward = encodeURIComponent(paramForward);

const thirdLoginParam = globalConfig.assignParamsObj(
  globalConfig.getHrefParamObj(),
  {
    // forward: forward,
    language: ''
  }
);

if (thirdLoginParam.gameId !== undefined) {
  delete thirdLoginParam.gameId;
}

const thirdLoginParamStr = globalConfig.objParamsToStrParams(thirdLoginParam);

export const FB_LOGIN_HREF = `${HTTP}${PASSPORT_HOST}web_facebook/login?${thirdLoginParamStr}`;
export const TWI_LOGIN_HREF = `${HTTP}${PASSPORT_HOST}web_twitter/login?${thirdLoginParamStr}`;
export const LINE_LOGIN_HREF = `${HTTP}${PASSPORT_HOST}web_line/login?${thirdLoginParamStr}`;
export const APPLE_LOGIN_HREF = `${HTTP}${PASSPORT_HOST}web_apple/login?${thirdLoginParamStr}`;
export const GOOGLE_PLAY_LOGIN_HREF = `${HTTP}${PASSPORT_HOST}web_google/login?${thirdLoginParamStr}`;
export const VK_LOGIN_HREF = `${HTTP}${PASSPORT_HOST}web_vk/login?${thirdLoginParamStr}`;

const LOGIN_ACTION = 'web_login/login';
const REGISTER_ACTION = 'web_register/register';
const GAME_LIST = 'ajax/game_list';
const GAME_INFO = 'ajax/get_game';
const CHECK_GAME_INFO = 'ajax/check_game';
const THIRD_LOGIN_LIST = 'ajax/get_login_type';
const CHECK_LOGIN = 'center/ajax/get_user_json';
const USER_TOKEN = 'user_info/get_user_bridge_token';
const CHECK_FORWARD = 'center/ajax/check_forward';
const LOGOUT_ACTION = 'web_login/logout';
const UID_TOKEN_ACTION = 'uid_token_login/web_login';
const UID_NEED_CKCODE_ACTION = 'uid_token_login/need_ckcode';
const RO_LOGIN_BIND_ACCOUNT = 'web_login/migrate_login';
export const GOOGLE_RECAPTCHA_KEY = '6Lc92KQUAAAAAF-m6BIUOeHs1uobQNlOwn1_vJk7';
export const CHANNEL_NAME = {
  facebook: 'Facebook',
  line: 'Line',
  naver: 'Naver',
  twitter: 'Twitter',
  googleplay: 'Google',
  vk: 'VK',
  apple: 'Apple'
};

export default {
  state: {
    gameId: null,
    gameList: [],
    thirdList: [],

    userName: '',
    userPhoto: '',
    userId: '',

    userAccount: '',
    password: '',
    repassword: '',
    isRemember: 1,

    userAccountState: true,
    passwordState: true,
    repasswordState: true,
    registerTermState: true,

    // forward参数是否合法：1合法，0不合法
    legalForwardState: false,

    isThirdPartyLogin: false,
    isAccoutLogin: false,
    isRoLogin: false,
    isRegister: false,
    isUidTokenLogin: false,

    letter: languages.getAll(),
    lang: languages.language,
    langList: languages.getLangText(),

    userAccountTips: '',
    passwordTips: '',
    repasswordTips: '',
    loginRequest: '',
    registerTermTips: '',
    registerRequest: '',
    isRtlDirection: languages.isRtlDirection(),

    passwordRepeatErrPos: -1 // 用于展示二次密码不一致的提示效果
  },
  getters: {
    isRtlDirection: state => {
      return state.isRtlDirection;
    }
  },
  mutations: {
    // 更新游戏id
    [UPDATE_GAMEID](state, gameid) {
      state.gameId = gameid;
    },
    // 更新游戏列表
    [UPDATE_GAME_LIST](state, gameList) {
      state.gameList = gameList;
    },
    [UPDATE_THIRD_LIST](state, list) {
      // 只有用户中心里面才有手机和邮箱登录，登录页面还没开发
      state.thirdList =
        list?.filter?.(item => !['email', 'phone'].includes(item)) || [];
    },
    // 更新游戏登入方式
    [UPDATE_GAME_LOGIN_TYPE](state) {
      if (mainHost === window.atob('Z25qb3kuaGs=') && +state.gameId === 386) {
        state.isRoLogin = true;
        return;
      }
      if (mainHost === window.atob('Z25qb3kuZ2FtZQ==') && +state.gameId === 456) {
        state.isRoLogin = true;
        return;
      }
      if (
        parseInt(state.gameList[state.gameId].USER_TYPE, 10) === 2 ||
        (mainHost === window.atob('Z25qb3kuaGs=') && +state.gameId === 386)
      ) {
        state.isThirdPartyLogin = true;
      } else {
        state.isAccoutLogin = true;
      }
    },
    // 通过userType更新游戏登入方式todo
    [UPDATE_GAME_LOGIN_TYPE_BY_USERTYPE](state, userType) {
      if (mainHost === window.atob('Z25qb3kuaGs=') && +state.gameId === 386) {
        state.isRoLogin = true;
        return;
      }
      if (mainHost === window.atob('Z25qb3kuZ2FtZQ==') && +state.gameId === 456) {
        state.isRoLogin = true;
        return;
      }
      if (+userType === 2) {
        state.isThirdPartyLogin = true;
      } else {
        state.isAccoutLogin = true;
      }
    },
    // 更新用户信息
    [UPDATE_USER_INFO](state, data) {
      state.userName = data.LOGIN_ACCOUNT;
      state.userId = data.ID;
      // state.userPhoto =
    },
    // 更新用户名
    [UPDATE_USER_ACCOUNT](state, username) {
      state.userAccount = username;
    },
    // 更新密码
    [UPDATE_USER_PASSWORD](state, password) {
      state.password = password;
    },
    // 更新二次输入
    [UPDATE_USER_REPASSWORD](state, repassword) {
      state.repassword = repassword;
    },
    // 更新记住账号
    [UPDATE_REMEMBER](state, isRemember) {
      state.isRemember = isRemember;
    },
    // 更新用户名输入提示状态
    [UPDATE_USER_ACCOUNT_STATE](state, tipState) {
      state.userAccountState = tipState;
    },
    // 更新密码输入提示状态
    [UPDATE_USER_PASSWORD_STATE](state, tipState) {
      state.passwordState = tipState;
    },
    // 更新二次输入密码提示状态
    [UPDATE_USER_REPASSWORD_STATE](state, tipState) {
      state.repasswordState = tipState;
    },
    [UPDATE_FAKE_PASSWORD_REPEAT](state, position) {
      state.passwordRepeatErrPos = position;
    },
    [UPDATE_REGISTER_TERM_STATE](state, tipState) {
      state.registerTermState = tipState;
    },
    [UPDATE_IS_LEGAL_FORWARD](state, legalForwardVal) {
      state.legalForwardState = legalForwardVal;
    },
    // 更新提示
    [UPDATE_TIPS](state) {
      state.userAccountTips = state.userAccountState
        ? state.letter[state.userAccountState]
        : '';
      state.passwordTips = state.passwordState
        ? state.letter[state.passwordState]
        : '';
      state.repasswordTips = state.repasswordState
        ? state.letter[state.repasswordState]
        : '';
      state.registerTermTips = state.registerTermState
        ? state.letter[state.registerTermState]
        : '';
      state.loginRequest = '';
      state.registerRequest = '';
    },
    [UPDATE_LOGIN_REQUEST](state, tip) {
      state.loginRequest = tip;
    },
    [UPDATE_REGISTER_REQUEST](state, tip) {
      state.registerRequest = tip;
    },
    // 切换语言
    [SWITCH_LANGUAGE](state) {
      state.letter = languages.getAll();
      state.lang = languages.language;
      state.isRtlDirection = languages.isRtlDirection();
    },
    [GOTO_REGISTER](state) {
      state.isRegister = true;
      state.isAccoutLogin = false;
      state.isUidTokenLogin = false;
    },
    [GOTO_LOGIN](state) {
      state.isAccoutLogin = true;
      state.isRegister = false;
      state.isUidTokenLogin = false;
    },
    [GO_BACK_SELECT_GAME](state) {
      state.isRegister = false;
      state.isAccoutLogin = false;
      state.isThirdPartyLogin = false;
      state.isUidTokenLogin = false;
      state.gameId = null;
    },
    [GOTO_UID_TOKEN_LOGIN](state) {
      state.isAccoutLogin = false;
      state.isRegister = false;
      state.isThirdPartyLogin = false;
      state.isUidTokenLogin = true;
    },
    [GO_BACK_SELECT_THIRD_PARTY_LOGIN](state) {
      state.isRegister = false;
      state.isAccoutLogin = false;
      state.isUidTokenLogin = false;
      state.isThirdPartyLogin = true;
    },
    [RESET_DATA](state) {
      state.userAccount = '';
      state.password = '';
      state.repassword = '';
      state.userAccountState = true;
      state.passwordState = true;
      state.repasswordState = true;
      state.registerTermState = true;
      state.userAccountTips = '';
      state.passwordTips = '';
      state.repasswordTips = '';
      state.registerTermTips = '';
    },
    [RESET_USER_INFO](state) {
      state.userName = '';
      state.userPhoto = '';
      state.userId = '';
    }
  },
  actions: {
    // 检查登录态
    [JUDGE_IS_LOGIN]({ commit }) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + PASSPORT_HOST + CHECK_LOGIN, {}).then(res => {
          if (parseInt(res.res.result, 10) === 1) {
            commit(UPDATE_USER_INFO, res.res.data);
          }
          resolve(parseInt(res.res.result, 10) === 1);
        });
      });
    },
    // 更新游戏id
    [UPDATE_GAMEID]({ commit, dispatch }, param) {
      commit(UPDATE_GAMEID, parseInt(param, 10));
    },
    // 更新游戏列表
    [UPDATE_GAME_LIST]({ commit }) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + HOME_HOST + GAME_LIST, {}).then(res => {
          commit(UPDATE_GAME_LIST, res.data.gameList);
          resolve();
        });
      });
    },
    // 检查游戏是否支持登录todo
    [CHECK_GAME]({ commit }, { gameId }) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + HOME_HOST + CHECK_GAME_INFO, { gameId }).then(json => {
          if (+json?.res.result) {
            resolve(json?.res.data);
          } else {
            reject();
          }
        });
      });
    },
    // 更新游戏列表
    [GET_GAME_INFO]({ commit }, { gameID }) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + HOME_HOST + GAME_INFO, { gameID }).then(res => {
          const PNS_GAMES = [191, 225, 227, 284, 221];
          const PNS_SKIP_BRANCH_CHECK =
            mainHost === 'pnsofficial.com' && PNS_GAMES.includes(+gameID);
          // 品牌不匹配跳轉遊戲選擇頁
          // 泰越斗罗195有两个域名需要兼容
          // 越南大天使之剑157有三个域名需要兼容vgm gamemart olgamevn
          const extraInfo = res?.data?.extra_info;
          if (
            mainHost !== extraInfo?.BRANDS &&
            gameID != 195 &&
            gameID != 157 &&
            // 特殊处理，越南精灵盛典活动登录需要用到
            gameID != 201 &&
            // 斗罗3D东南亚
            gameID != 274 &&
            // 越南荣耀大天使与对外域名不匹配, 周年活动需要用到
            gameID != 261 &&
            // 帝国slg品牌和对外域名不匹配
            gameID != 269 &&
            // 越南大掌柜新版储值页登录使用
            gameID != 215 &&
            // 末日新版储值页使用pnsofficial域名，跳过品牌检测
            !PNS_SKIP_BRANCH_CHECK
          ) {
            window.location.href = `//${window.location.host}/platform/login.html`;
            return;
          }
          gameID = +gameID;
          let gameList = {};
          gameList[gameID] = extraInfo && JSON.parse(JSON.stringify(extraInfo));
          commit(UPDATE_GAME_LIST, gameList);
          resolve();
        });
      });
    },
    // 更新串接登录列表
    [UPDATE_THIRD_LIST]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + HOME_HOST + THIRD_LOGIN_LIST, {
          gameId: state.gameId
        }).then(json => {
          if (parseInt(json.res.result, 10) === 1) {
            let res = [];
            if (
              Object.prototype.toString.call(json.res.data) === '[object Array]'
            ) {
              json.res.data.map(item => {
                if (!/^(gamecenter|migrate_code)$/.test(item)) {
                  res.push(item);
                }
              });
            }

            commit(UPDATE_THIRD_LIST, res);
          }
          resolve();
        });
      });
    },
    // 更新登录方式
    [UPDATE_GAME_LOGIN_TYPE]({ commit }) {
      commit(UPDATE_GAME_LOGIN_TYPE);
    },
    // 通过userType更新登录方式
    [UPDATE_GAME_LOGIN_TYPE_BY_USERTYPE]({ commit }, param) {
      commit(UPDATE_GAME_LOGIN_TYPE_BY_USERTYPE, param);
    },
    // 更新用户密码
    [UPDATE_USER_PASSWORD]({ commit }, param) {
      commit(UPDATE_USER_PASSWORD, param);
    },
    // 更新用户名
    [UPDATE_USER_ACCOUNT]({ commit }, param) {
      commit(UPDATE_USER_ACCOUNT, param);
    },
    // 更新二次密码
    [UPDATE_USER_REPASSWORD]({ commit }, param) {
      commit(UPDATE_USER_REPASSWORD, param);
    },
    [UPDATE_REMEMBER]({ commit, state }) {
      commit(UPDATE_REMEMBER, Number(!state.isRemember));
    },
    // 校验用户名
    [JUDGE_USER_ACCOUNT]({ commit }, param) {
      if (param) {
        if (!accountNameValidate(param)) {
          commit(UPDATE_USER_ACCOUNT_STATE, 'accountValidateMsg');
        } else {
          commit(UPDATE_USER_ACCOUNT_STATE, false);
        }
      } else {
        commit(UPDATE_USER_ACCOUNT_STATE, 'accountName');
      }
      commit(UPDATE_TIPS);
    },
    // 校验密码
    [JUDGE_USER_PASSWORD]({ commit }, param) {
      if (param) {
        if (!pwdValidate(param)) {
          commit(UPDATE_USER_PASSWORD_STATE, 'pwdValidateMsg');
        } else {
          commit(UPDATE_USER_PASSWORD_STATE, false);
        }
      } else {
        commit(UPDATE_USER_PASSWORD_STATE, 'password');
      }
      commit(UPDATE_TIPS);
    },
    // 校验二次密码
    [JUDGE_USER_REPASSWORD]({ commit, state }, param) {
      if (param && param === state.password) {
        commit(UPDATE_USER_REPASSWORD_STATE, false);
        commit(UPDATE_FAKE_PASSWORD_REPEAT, -1);
      } else {
        if (!state.password) {
          commit(UPDATE_FAKE_PASSWORD_REPEAT, -1);
        } else {
          // 找到错误的位置
          let i = 0;
          while (i < param.length && i < state.password.length) {
            if (param[i] !== state.password[i]) {
              break;
            }
            i++;
          }
          commit(UPDATE_FAKE_PASSWORD_REPEAT, i);
        }
        commit(UPDATE_USER_REPASSWORD_STATE, 'repeatPassword');
      }
      commit(UPDATE_TIPS);
    },
    [SHOW_FAKE_PASSWORD_REPEAT]({ commit }, param) {
      commit(UPDATE_FAKE_PASSWORD_REPEAT, param);
    },
    // 校验注册是否同意条款
    [JUDGE_REGISTER_TERM]({ commit, state }, param) {
      if (param) {
        commit(UPDATE_REGISTER_TERM_STATE, false);
      } else {
        commit(UPDATE_REGISTER_TERM_STATE, 'checkServiceTips');
      }
      commit(UPDATE_TIPS);
    },
    // 校验Forward是否合规
    [JUDGE_FORWARD_IS_VERIFY]({ commit, state }, forward) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + PASSPORT_HOST + CHECK_FORWARD, {
          forward: forward
        })
          .then(res => {
            if (+res.res.result === 1) {
              commit(UPDATE_IS_LEGAL_FORWARD, res?.res?.data?.LEGAL_FORWARD);
              resolve(res?.res?.data?.LEGAL_FORWARD);
            } else {
              resolve(res?.res?.msg);
            }
          })
          .catch(err => reject(err));
      });
    },
    [GET_USER_TOKEN]({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + PASSPORT_HOST + USER_TOKEN, params).then(res => {
          resolve(res?.res?.data?.token);
        });
      });
    },
    // 登录前检查
    [LOGIN_CHECK]({ state, commit, dispatch }) {
      return dispatch(JUDGE_USER_ACCOUNT, state.userAccount)
        .then(dispatch(JUDGE_USER_PASSWORD, state.password))
        .then(() => {
          return !state.userAccountState && !state.passwordState;
        });
    },
    // 注册前检查
    [REGISTER_CHECK]({ state, commit, dispatch }, param) {
      return dispatch(JUDGE_REGISTER_TERM, param)
        .then(dispatch(JUDGE_USER_ACCOUNT, state.userAccount))
        .then(dispatch(JUDGE_USER_PASSWORD, state.password))
        .then(dispatch(JUDGE_USER_REPASSWORD, state.repassword))
        .then(() => {
          return (
            !state.registerTermState &&
            !state.userAccountState &&
            !state.passwordState &&
            !state.repasswordState
          );
        });
    },
    // 2025.8.13 RO登录页绑定游戏角色
    [GO_RO_LOGIN_BIND_ACCOUNT]({ state, commit }, param) {
      return new Promise((resolve, reject) => {
        const params = {
          uname: state.userAccount,
          password: encryption(state.password),
          migrate_login_token: globalConfig.getHrefParam('migrateLoginToken'),
          sns_type: globalConfig.getHrefParam('snsType'),
          language: state.lang,
          timeZone: encodeURIComponent(globalConfig.getTimeZone()),
          game_id: state.gameId,
          web_source: 'platform'
        };
        let linkParam = globalConfig.getHrefParamObj();
        if (linkParam.gameId !== undefined) {
          delete linkParam.gameId;
        }
        getJSONWithoutEntryParam(
          HTTP + PASSPORT_HOST + RO_LOGIN_BIND_ACCOUNT,
          globalConfig.assignParamsObj(linkParam, params)
        ).then(({ errmsg, res }) => {
          if (parseInt(res.result, 10) === 1) {
            resolve({
              result: true,
              forward: res.forward
            });
          } else {
            commit(UPDATE_LOGIN_REQUEST, res?.msg.split('[')[0]);
            resolve({
              result: false
            });
          }
        });
      });
    },
    // 执行登录
    [GO_LOGIN]({ state, commit }, param) {
      return new Promise((resolve, reject) => {
        const params = {
          uname: state.userAccount,
          password: encryption(state.password),
          forward: param.forward || forward,
          // "g_recaptcha": param.token,
          language: state.lang,
          remember: state.isRemember,
          game_id: state.gameId,
          // 2017.1.17
          // 用来标记从平台登录页登录注册的数据，并在后端进行过滤（避免非h5游戏产生web端新用户数据）
          web_source: 'platform',
          timeZone: encodeURIComponent(globalConfig.getTimeZone())
        };
        let linkParam = globalConfig.getHrefParamObj();
        if (linkParam.gameId !== undefined) {
          delete linkParam.gameId;
        }
        getJSONWithoutEntryParam(
          HTTP + PASSPORT_HOST + LOGIN_ACTION,
          globalConfig.assignParamsObj(linkParam, params)
        ).then(({ errmsg, res }) => {
          if (parseInt(res.result, 10) === 1) {
            resolve({
              result: true,
              forward: res.forward
            });
          } else {
            commit(UPDATE_LOGIN_REQUEST, res?.msg.split('[')[0]);
            resolve({
              result: false
            });
          }
        });
      });
    },
    // 执行注册
    [GO_REGISTER]({ state, commit }, param) {
      return new Promise(resolve => {
        const params = {
          uname: state.userAccount,
          password: encryption(state.password),
          repassword: encryption(state.repassword),
          forward: param.forward || forward,
          // "g_recaptcha": param.token,
          language: state.lang,
          // 2021.07.29
          // 非h5游戏注册时，不携带gameid，避免非游戏内注册（如预约页注册）归因时归因到游戏内注册
          // 2021.08.31
          // 开回去
          game_id: state.gameId,
          // 2017.1.17
          // 用来标记从平台登录页登录注册的数据，并在后端进行过滤（避免非h5游戏产生web端新用户数据）
          web_source: 'platform',
          timeZone: encodeURIComponent(globalConfig.getTimeZone())
        };
        let linkParam = globalConfig.assignParamsObj(
          globalConfig.getHrefParamObj(),
          params
        );
        if (linkParam.gameId !== undefined) {
          delete linkParam.gameId;
        }
        getJSONWithoutEntryParam(
          HTTP + PASSPORT_HOST + REGISTER_ACTION,
          linkParam
        ).then(({ errmsg, res }) => {
          if (parseInt(res.result, 10) === 1) {
            resolve({
              result: true,
              forward: res.forward
            });
          } else {
            commit(UPDATE_REGISTER_REQUEST, res?.msg.split('[')[0]);
            resolve({
              result: false
            });
          }
        });
      });
    },
    // 登出
    [GO_LOGOUT]({ commit, state }) {
      return new Promise(resolve => {
        getJSON(HTTP + PASSPORT_HOST + LOGOUT_ACTION, {
          forward: forward,
          language: state.lang
        }).then(({ errmsg, res }) => {
          resolve({
            result: parseInt(res.result, 10) === 1,
            forward: res.forward
          });
        });
      });
    },
    // 切换语言
    [SWITCH_LANGUAGE]({ commit, dispatch }, param) {
      languages.setLanguage(param);
      commit(SWITCH_LANGUAGE);
      commit(UPDATE_TIPS);
    },
    [GOTO_REGISTER]({ commit }) {
      commit(GOTO_REGISTER);
      commit(RESET_DATA);
    },
    [GOTO_LOGIN]({ commit }) {
      commit(GOTO_LOGIN);
      commit(RESET_DATA);
    },
    [GO_BACK_SELECT_GAME]({ commit }) {
      commit(GO_BACK_SELECT_GAME);
    },
    [RESET_USER_INFO]({ commit }) {
      commit(RESET_DATA);
      commit(RESET_USER_INFO);
    },
    [GO_UID_TOKEN_LOGIN]({ state }, param) {
      return new Promise(resolve => {
        const params = {
          uid: param.uid,
          token: param.token,
          ckcode: param.ckcode,
          language: state.lang,
          // 2017.1.17
          // 用来标记从平台登录页登录注册的数据，并在后端进行过滤（避免非h5游戏产生web端新用户数据）
          web_source: 'platform',
          timeZone: encodeURIComponent(globalConfig.getTimeZone()),
          gameId: param.gameId,
          packageName: param.packageName || ''
        };
        let linkParam = globalConfig.getHrefParamObj();
        if (linkParam.gameId !== undefined) {
          delete linkParam.gameId;
        }
        getJSONWithoutEntryParam(
          HTTP + PASSPORT_HOST + UID_TOKEN_ACTION,
          globalConfig.assignParamsObj(linkParam, params)
        ).then(({ errmsg, res }) => {
          if (parseInt(res.result, 10) === 1) {
            resolve({
              result: true
            });
          } else {
            resolve({
              result: false,
              msg: errmsg
            });
          }
        });
      });
    },
    [CHECK_NEED_VERIFICATION_CODE]() {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + PASSPORT_HOST + UID_NEED_CKCODE_ACTION, {})
          .then(res => {
            if (+res.res.result === 1) {
              resolve({
                result: 1,
                data: res?.res?.data
              });
            } else {
              resolve({
                result: 0,
                msg: res?.res?.msg
              });
            }
          })
          .catch(err => reject(err));
      });
    },
    // 二维码登录 - 生成二维码
    [GENERATE_QR_CODE]({ state }, params) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + PASSPORT_HOST + 'web_qr_code_login/code_generate', params)
          .then(({ res }) => {
            resolve(res);
          })
          .catch(err => reject(err));
      });
    },
    // 二维码登录 - 检查二维码状态
    [CHECK_QR_CODE_STATUS]({ state }, params) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + PASSPORT_HOST + 'web_qr_code_login/qr_code_check', params)
          .then(({ res }) => {
            resolve(res);
          })
          .catch(err => reject(err));
      });
    },
    // 二维码登录 - 处理登录
    [HANDLE_QR_CODE_LOGIN]({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        // 添加 forward 参数，后端会验证并返回安全的跳转地址
        const requestParams = {
          ...params,
          forward: forward
        };
        getJSON(HTTP + PASSPORT_HOST + 'web_qr_code_login/qr_code_login', requestParams)
          .then(({ res }) => {
            if (parseInt(res.result, 10) === 1) {
              // 登录成功后需要判断登录状态
              dispatch(JUDGE_IS_LOGIN);
            }
            resolve(res);
          })
          .catch(err => reject(err));
      });
    }
  },
  modules: {
    services,
    logoConfig
  }
};
